var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { decodeHtmlEntities } from "../../assets/js/helpers/utils";
var LogPurchasingMap = /** @class */ (function () {
    function LogPurchasingMap(element) {
        var _this = this;
        this.decodeHtmlEntities = decodeHtmlEntities;
        this.mapBlock = element;
        this.body = document.querySelector('body');
        this.pageOverlay = document.querySelector('[data-page-overlay]');
        this.pageLoader = document.querySelector('[data-page-loader]');
        this.mapContainer = this.mapBlock.querySelector('.map');
        this.locations = this.mapBlock.querySelectorAll('.location-item');
        var clusterSvg = window.btoa("\n                <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56 56\" fill=\"none\">\n                <circle cx=\"28\" cy=\"28\" r=\"20\" fill=\"#F26A21\"/>\n                <circle cx=\"28\" cy=\"28\" r=\"24\" stroke=\"#fff\" stroke-opacity=\".8\" stroke-width=\"8\"/>\n                </svg>");
        this.markerClusterRenderer = {
            render: function (_a) {
                var count = _a.count, position = _a.position;
                return new google.maps.Marker({
                    label: { text: String(count), color: "white", fontSize: "14px", fontWeight: "600" },
                    icon: {
                        url: "data:image/svg+xml;base64,".concat(clusterSvg),
                        scaledSize: new google.maps.Size(56, 56),
                    },
                    position: position,
                    // adjust zIndex to be above other markers
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                });
            }
        };
        this.mapCountriesData = [];
        this.mapMarkers = [];
        this.activeLocations = [];
        this.wordpressApiLink = "".concat(window.location.protocol, "//").concat(window.location.hostname, "/wp-admin/admin-ajax.php?action=specified_map_locations");
        this.mapsLoader = new Loader({
            apiKey: "AIzaSyDBa4C7O9vX_tV_mixTW3_fXSR976LeoXg",
        });
        this.mapsLoader.load().then(function () { return __awaiter(_this, void 0, void 0, function () {
            var Map, _a, lat, lng;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.mapBlock.classList.remove('loading');
                        return [4 /*yield*/, google.maps.importLibrary("maps")];
                    case 1:
                        Map = (_b.sent()).Map;
                        this.googleMap = new Map(this.mapContainer, {
                            center: { lat: -34.397, lng: 150.644 },
                            zoom: 8,
                            mapId: 'c7cf9227d1835981',
                            disableDefaultUI: true,
                        });
                        _a = this.locations[0].dataset.location.split(',').map(Number), lat = _a[0], lng = _a[1];
                        this.googleMap.panTo({ lat: lat, lng: lng });
                        this.googleMap.zoom = 8;
                        this.loadMarkersApiData();
                        this.addEventListeners();
                        return [2 /*return*/];
                }
            });
        }); });
    }
    LogPurchasingMap.prototype.addEventListeners = function () {
        var _this = this;
        this.locations.forEach(function (location) {
            var showOnMapToggle = location.querySelector('[data-show-on-map]');
            if (showOnMapToggle) {
                showOnMapToggle.addEventListener('click', _this.toggleLocation.bind(_this));
            }
            var pricesBtn = location.querySelector('[data-accordion-target]');
            if (pricesBtn) {
                pricesBtn.addEventListener('click', LogPurchasingMap.scrollToPrices.bind(_this));
            }
        });
    };
    LogPurchasingMap.scrollToPrices = function (event) {
        event.preventDefault();
        var currentItem = event.currentTarget;
        var scrollToBlock = document.querySelector('.log-purchasing');
        if (scrollToBlock) {
            scrollToBlock.scrollIntoView();
        }
        var accordionValue = currentItem.getAttribute('data-accordion-target');
        var accordionButton = scrollToBlock.querySelector('[data-accordion-target="' + accordionValue + '"]');
        if (accordionButton) {
            accordionButton.click();
        }
    };
    LogPurchasingMap.prototype.toggleLocation = function (event) {
        // On click move to location
        var currentItem = event.currentTarget;
        var location = currentItem.parentElement.parentElement.parentElement.parentElement;
        var locationId = parseInt(location.id);
        var locationIndex = this.apiResults.data.findIndex(function (object) { return object.id === locationId; });
        var activeItemLocation = { lat: this.apiResults.data[locationIndex]['location']['lat'], lng: this.apiResults.data[locationIndex]['location']['lng'] };
        this.googleMap.zoom = 13;
        this.googleMap.panTo(activeItemLocation);
    };
    LogPurchasingMap.prototype.loadMarkersApiData = function () {
        var _this = this;
        // Load markers based on location id
        // Set all locations
        this.locations.forEach(function (location) { return _this.activeLocations.push(parseInt(location.id)); });
        this.body.classList.add('no-scroll');
        this.pageOverlay.classList.add('visible');
        this.pageLoader.classList.add('active');
        var options = {
            method: 'POST',
            body: JSON.stringify({ locations: this.activeLocations })
        };
        fetch(this.wordpressApiLink, options)
            .then(function (response) { return response.json(); })
            .then(function (response) {
            _this.apiResults = response;
        })
            .catch(function (error) {
            console.error('Fetch error:', error);
        })
            .finally(function () {
            _this.body.classList.remove('no-scroll');
            _this.setLocationMarkers();
        });
    };
    LogPurchasingMap.prototype.setLocationMarkers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var AdvancedMarkerElement, bounds;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, google.maps.importLibrary("marker")];
                    case 1:
                        AdvancedMarkerElement = (_a.sent()).AdvancedMarkerElement;
                        bounds = new google.maps.LatLngBounds();
                        this.apiResults.data.forEach(function (location) {
                            // Custom marker content
                            var itemMarker = document.createElement('div');
                            itemMarker.className = 'item-marker color-reset';
                            itemMarker.setAttribute('data-item-id', location.id);
                            itemMarker.textContent = '';
                            if (location['locationIcon'] === null) {
                                itemMarker.className = 'item-marker icon color-reset';
                                itemMarker.textContent = '';
                            }
                            else {
                                itemMarker.className = 'item-marker color-reset';
                                itemMarker.innerHTML = '<img src="' + location['locationIcon'] + '" alt="' + location['title'] + '">';
                            }
                            // Set marker with custom content
                            var marker = new AdvancedMarkerElement({
                                title: _this.decodeHtmlEntities(location['title']),
                                map: _this.googleMap,
                                position: { lat: location['location']['lat'], lng: location['location']['lng'] },
                                content: itemMarker,
                            });
                            bounds.extend({ lat: location['location']['lat'], lng: location['location']['lng'] }); // Extend boundaries with markers
                            // Set location window content
                            var infoWindowContent = document.createElement('div');
                            infoWindowContent.className = 'info-window-content';
                            infoWindowContent.innerHTML = '<h4 class="color-reset">' + location['title'] + '</h4>';
                            infoWindowContent.innerHTML += '<p class="color-reset">' + location['address'] + '</p>';
                            if (location['phoneNumber'] !== '' && location['phoneNumber'] !== null) {
                                // If phone number not empty
                                infoWindowContent.innerHTML += '<a class="color-reset" href="tel:' + location['phoneNumber'] + '">' + location['phoneNumber'] + '</a>';
                            }
                            if (location['email'] !== '' && location['email'] !== null) {
                                // If email not empty
                                infoWindowContent.innerHTML += '<a class="color-reset" href="mailto:' + location['email'] + '">' + location['email'] + '</a>';
                            }
                            if (location['workingHours']['type'] !== 'no-hours') {
                                if (location['workingHours']['type'] === '247') {
                                    // If working hours type is 24/7
                                    infoWindowContent.innerHTML += '<p class="color-reset">' + location['workingHours']['translation'] + '</p>';
                                }
                                else if (location['workingHours']['type'] === 'same') {
                                    // If same for all days
                                    infoWindowContent.innerHTML += '<p class="color-reset">' + location['workingHours']['translation']
                                        + ': ' + location['workingHours']['openFrom'] + ' - ' + location['workingHours']['openTill'] + '</p>';
                                }
                                if (location['workingHours']['type'] === 'same-custom') {
                                    // If working hours type is custom input text
                                    infoWindowContent.innerHTML += '<p class="color-reset">' + location['workingHours']['translation'] + '</p>';
                                }
                                else {
                                    // If specific work time for specific days & dates
                                    var workingHtml_1 = '<ul>';
                                    // if not empty
                                    if (location['workingHours']['dayList']) {
                                        location['workingHours']['dayList'].forEach(function (day) {
                                            workingHtml_1 += '<li>';
                                            workingHtml_1 += day['dayTranslation'] + ': ';
                                            if (day['status'] === false) {
                                                workingHtml_1 += day['closedText'];
                                            }
                                            else {
                                                workingHtml_1 += day['openFrom'] + ' - ' + day['openTill'];
                                            }
                                            workingHtml_1 += '</li>';
                                        });
                                    }
                                    workingHtml_1 += '</ul>';
                                    infoWindowContent.innerHTML += workingHtml_1;
                                }
                            }
                            marker.addListener("click", function () {
                                // Create new info window & content
                                if (_this.mapInfoWindow && _this.mapPreviousActiveMarker === marker.title) {
                                    // If there is mapInfoWindow and previousActiveMarker is the same as current marker
                                    // Clicking same marker again - close info window
                                    _this.mapInfoWindow.close();
                                    _this.mapInfoWindow = null;
                                    _this.mapPreviousActiveMarker = null;
                                }
                                else if (_this.mapInfoWindow && _this.mapPreviousActiveMarker !== marker.title) {
                                    // If there is mapInfoWindow and previousActiveMarker is not the same as current marker
                                    // Clicking different marker - close previous info window and open new
                                    _this.mapInfoWindow.close();
                                    _this.mapInfoWindow = null;
                                    _this.mapInfoWindow = new google.maps.InfoWindow({
                                        content: infoWindowContent,
                                    });
                                    _this.mapInfoWindow.open({
                                        anchor: marker,
                                        map: _this.googleMap,
                                    });
                                    _this.mapPreviousActiveMarker = marker.title;
                                    // Set previousActiveMarker to null on info window close by clicking x button
                                    google.maps.event.addListener(_this.mapInfoWindow, 'closeclick', function () { return _this.mapPreviousActiveMarker = null; });
                                }
                                else {
                                    // If no previousActiveMarker and no info window
                                    // First time clicking on marker - open info window
                                    _this.mapInfoWindow = new google.maps.InfoWindow({
                                        content: infoWindowContent,
                                    });
                                    _this.mapInfoWindow.open({
                                        anchor: marker,
                                        map: _this.googleMap,
                                    });
                                    _this.mapPreviousActiveMarker = marker.title;
                                    // Set previousActiveMarker to null on info window close by clicking x button
                                    google.maps.event.addListener(_this.mapInfoWindow, 'closeclick', function () { return _this.mapPreviousActiveMarker = null; });
                                }
                            });
                            _this.mapMarkers.push(marker);
                        });
                        this.googleMap.maxDefaultZoom = 15;
                        this.googleMap.fitBounds(bounds); // Fit map to bound all markers
                        google.maps.event.addListenerOnce(this.googleMap, "bounds_changed", function () {
                            this.setZoom(Math.min(this.getZoom(), this.maxDefaultZoom));
                        });
                        this.markerCluster = new MarkerClusterer({
                            map: this.googleMap,
                            markers: this.mapMarkers,
                            renderer: this.markerClusterRenderer,
                            algorithmOptions: { maxZoom: 13 }
                        });
                        this.pageOverlay.classList.remove('visible');
                        this.pageLoader.classList.remove('active');
                        return [2 /*return*/];
                }
            });
        });
    };
    return LogPurchasingMap;
}());
var logPurchasingMapBlocks = document.querySelectorAll('[data-log-purchasing-map-block]');
logPurchasingMapBlocks.forEach(function (logPurchasingMapBlock) {
    new LogPurchasingMap(logPurchasingMapBlock);
});
